import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53061)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1383 41.3792H0.862596C0.386523 41.3792 0.000488281 40.9932 0.000488281 40.5171V9.48271C0.000488281 9.00664 0.386523 8.62061 0.862596 8.62061H49.1384C49.6145 8.62061 50.0005 9.00664 50.0005 9.48271V40.5171C50.0004 40.9933 49.6144 41.3792 49.1383 41.3792Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.7939 8.62109H11.208V41.3798H38.7939V8.62109Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.862596 8.62061C0.386523 8.62061 0.000488281 9.00654 0.000488281 9.48262V40.517C0.000488281 40.9931 0.386523 41.3791 0.862596 41.3791H11.2074V8.62061H0.862596Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1388 8.62061H38.7939V41.3791H49.1388C49.6148 41.3791 50.0009 40.9931 50.0009 40.517V9.48262C50.0009 9.00654 49.6148 8.62061 49.1388 8.62061Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.2327 28.7852L35.3482 25.8622L34.1744 25.2753C33.8452 25.1106 33.6567 24.7552 33.7054 24.3902L34.0874 21.5267L31.9216 22.1568C31.4432 22.2961 30.9467 22.0017 30.8391 21.5153L30.6317 20.5778L28.5982 22.9577C28.3163 23.2876 27.7793 23.0356 27.8528 22.6079L28.7213 17.5583L27.3917 17.922C27.0033 18.0282 26.5931 17.8515 26.4038 17.4962L25.0037 14.8721V14.8682L25.0027 14.8701L25.0016 14.8682V14.8721L23.6015 17.4962C23.412 17.8514 23.0018 18.0281 22.6135 17.922L21.2838 17.5583L22.1522 22.6079C22.2258 23.0354 21.6887 23.2875 21.4067 22.9577L19.3732 20.5778L19.1658 21.5153C19.0582 22.0018 18.5617 22.296 18.0833 22.1568L15.9176 21.5267L16.2995 24.3902C16.3482 24.7551 16.1598 25.1106 15.8306 25.2753L14.6567 25.8622L19.7723 28.7853C20.3021 29.0882 20.5344 29.7303 20.3206 30.3019L19.8833 31.4716L24.2666 31.0973C24.5092 31.0766 24.7156 31.2719 24.7085 31.5152L24.5704 36.207H25.4325L25.2943 31.515C25.2872 31.2717 25.4936 31.0764 25.7362 31.0971L30.1216 31.4716L29.6842 30.3019C29.4707 29.7302 29.7028 29.088 30.2327 28.7852Z",
					fill: "#CD343C"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53061",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCaFlag);
export { ForwardRef as ReactComponent };
